import { ldb, state, waitFor } from '@codesuma/baseline'
import { APP_VERSION } from '../configs/app'

// Native only: asks for a store rating with the system's own prompt, through
// @capawesome/capacitor-app-review. It asks once the app has been used on a
// few different days, right after something went well — a task ticked off, a
// new occasion or event saved — and at most once a version. Whether the prompt
// really shows is the store's call: Apple shows it at most three times a year.
//
// The menu's rating row opens the store's review page whenever the user wants.

const DAYS_KEY = 'rating-days' // how many different days the app was used on
const LAST_DAY_KEY = 'rating-last-day'
const ASKED_KEY = 'rating-asked' // the version it last asked in
const MIN_DAYS = 3
const DELAY_MS = 800 // lets the tick or the page change finish before the prompt covers it
const APP_STORE_ID = '6792455885' // iOS needs it to open the page; Play finds the app itself

const plugin = () => (window as any).Capacitor?.Plugins?.AppReview

// Once per calendar day. The calendar broadcasts 'today' when it notices a new
// day, which is the app coming back to the front on another day.
function countDay() {
    const day = new Date().toDateString()
    if (ldb.get(LAST_DAY_KEY) === day) return
    ldb.set(LAST_DAY_KEY, day)
    // Empty and not a number when never set: ldb answers a missing key with ''.
    ldb.set(DAYS_KEY, Number(ldb.get(DAYS_KEY)) + 1)
}

export default {
    init() {
        if (!plugin()) return // web: there is no store to rate in
        countDay()
        state.on('today', countDay)
    },
    available: () => !!plugin(),
    // Called where something just went well.
    goodMoment() {
        if (!plugin()) return
        if (Number(ldb.get(DAYS_KEY)) < MIN_DAYS) return
        if (String(ldb.get(ASKED_KEY)) === APP_VERSION) return
        ldb.set(ASKED_KEY, APP_VERSION)
        waitFor(DELAY_MS)
            .then(() => plugin().requestReview())
            .catch((err: unknown) => console.warn('rating: the review prompt failed', err))
    },
    open() {
        plugin()?.openAppStore({ appId: APP_STORE_ID })
    },
}
